import { useMsal } from '@azure/msal-react'
import { loginRequest } from './../../authConfig'
import { Button } from '@fluentui/react-components'
import { IPublicClientApplication } from '@azure/msal-browser'

function handleLogin(instance: IPublicClientApplication) {
  instance.loginRedirect(loginRequest).catch((e: Error) => {
    console.error(e)
  })
}

export const SignInButton = () => {
  const { instance } = useMsal()

  return (
    <Button
      data-testid="SignInBtn"
      appearance="primary"
      onClick={() => handleLogin(instance)}
    >
      Logga in
    </Button>
  )
}
